module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0151.jpg?v=c09c767f";